import {AddressType} from "../../../enums";
import {
    ColumnType,
    DetailGridIgnore,
    DisplayName,
    TableColumn,
    TableIgnore,
    yascMaxLength,
    yascMinLength,
    yascRequired,
} from '@yasc/yasc-material-components';

export class AddressDetailRes {
    @TableIgnore(true)
    @DetailGridIgnore()
    public id!: number;

    @TableIgnore(true)
    @DetailGridIgnore()
    public type!: AddressType;

    @DisplayName('general_streetName')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public streetName!: string;

    @DisplayName('general_streetNumber')
    @yascRequired()
    @yascMaxLength(20)
    public streetNumber!: string;

    @DisplayName('general_city')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public city!: string;

    @DisplayName('general_zipCode')
    @yascRequired()
    @yascMinLength(3)
    @yascMaxLength(10)
    public zipCode!: string;

    @DisplayName('general_federalState')
    @yascRequired()
    @yascMaxLength(100)
    public federalState!: string;

    @DisplayName('general_country')
    @yascRequired()
    @yascMinLength(2)
    @yascMaxLength(100)
    public country!: string;

    @DisplayName('generalDefault')
    @TableColumn(ColumnType.Switch)
    public default!: boolean;

    toString() {
        return this.streetName + ' ' + this.streetNumber + ', ' + this.zipCode + ' ' + this.city + ', ' + this.country;
    }
}

export class AddressReq {
    id: number = 0;
    city: string = "";
    country: string = "";
    streetName: string = "";
    streetNumber: string = "";
    zipCode: string = "";
    federalState?: string = "";
    default!: boolean;
    type!: AddressType;

    constructor(addressRes?: AddressDetailRes) {
        if (addressRes !== undefined) {
            this.id = addressRes.id;
            this.city = addressRes.city;
            this.country = addressRes.country;
            this.streetName = addressRes.streetName;
            this.streetNumber = addressRes.streetNumber;
            this.zipCode = addressRes.zipCode;
            this.federalState = addressRes.federalState;
            this.default = addressRes.default;
            this.type = addressRes.type;
        }
    }
}
